import { serviceRequest, uploadFileRequest } from './service-request';
import { buildQueryString } from '@cognitoforms/utils/url-helper';
import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import type { FileDataRef } from '@cognitoforms/types/server-types/model/file-data-ref';

export async function getPermalink(id: string) {
	const res = await serviceRequest(`forms/admin/permalink/${id}`, {}, { method: 'GET' });
	if (res.error)
		throw res.error;
	else
		return res;
};
export async function getDownloadUrl(file: FileDataRef) {
	return await getPermalink(file.Id) + buildQueryString({
		id: file.Id,
		name: file.Name,
		ct: file.ContentType,
		size: file.Size?.toString()
	});
};
export interface UploadFileOptions {
	encrypt?: boolean;
	onProgress?: (event: ProgressEvent) => void;
};

export async function uploadFile(file: File, options: UploadFileOptions = {}): Promise<FileDataRef> {
	const { encrypt, onProgress } = options;
	const params: Record<string, string> = {};
	if (encrypt)
		params['encrypt'] = '';
	const data = new FormData();
	data.append('file', file);

	return uploadFileRequest('forms/admin/file', data, params, onProgress) as Promise<FileDataRef>;
}

export async function getAnonymousDownloadUrl(fileId: string) {
	return serviceRequest('svc/file-attachment/download-link', null, { method: 'GET', query: { fileId } });
}

export function getAdminUrl(fileData: FileDataRef) {
	return `${CognitoConfiguration.SiteUrl}forms/admin/file?id=${fileData.Id}&ct=${fileData.ContentType}&at=0`;
}

export function getThumbnailUrl(fileId: string) {
	return `${CognitoConfiguration.SiteUrl}forms/admin/thumbnail?id=${fileId}`;
}